import React from 'react';
import classnames from 'classnames';

import { isElementOfType } from '../../utilities/components';

import { Width } from './types';
import { WpTabs } from '../tabs';

import './WpPageHeader.scss';

export interface Props {
  children?: React.ReactNode;
  width?: Width;
  sticky?: boolean;
  slim?: boolean;
  bordered?: boolean;
}

const WpPageHeader: React.FC<Props> = ({ children, width, sticky = false, slim = false, bordered = true }: Props) => {
  const childrenLength = React.Children.count(children);
  const isLastElementTabs = children && childrenLength > 1 && isElementOfType(children[childrenLength - 1], WpTabs);

  const baseClassName = 'WpPageHeader';
  const classes = classnames(
    baseClassName,
    `${baseClassName}--${width}`,
    sticky ? `${baseClassName}--sticky` : false,
    slim ? `${baseClassName}--slim` : false,
    bordered ? `${baseClassName}--bordered` : false,
    isLastElementTabs ? `${baseClassName}--has-tabs` : false
  );

  return (
    <div className={classes}>
      <div className={`${baseClassName}__content ${baseClassName}__content--${width}`}>
        {React.Children.map(children, (child: React.ReactElement<any>) => {
          if (child && isElementOfType(child, [WpTabs])) {
            return <div className={`${baseClassName}__content__tabs`}>{React.cloneElement(child, { width })}</div>;
          }
          return child;
        })}
      </div>
    </div>
  );
};

export default WpPageHeader;
